module.exports = __webpack_public_path__ + "img/Macon_01_MG.cbcfaf43.jpg";